import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CardActionArea, CardHeader, IconButton } from "@mui/material";
import * as helper from "../../utils/Utils";
import SizeSelector from "./SizeSelector";
import { useState } from "react";
import { addItemToCartMutation } from "../../utils/Querys";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

export default function ItemCardPhone({ pastery }) {
  const [selectedPrice, setSelectedPrice] = useState();
  const addToCart = addItemToCartMutation();
  return (
    <Card
      sx={{
        display: "flex",
        maxWidth: "450px",
        height:"200px",
        m: "4px",
        width: "95%",
      }}
    >
      <CardMedia
        component="img"
        src={pastery.image}
        sx={{ 
          width: "100px", 
          height:"100px",
          objectFit: "cover",
          alignSelf: "center",
          margin:"inherit",
          minWidth: "100px",
          minHeight: "100px"
       }}
        alt={pastery.name}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          whiteSpace: "nowrap",
        }}
      >
        <CardHeader
          title={pastery.name + " "}
          titleTypographyProps={{textAlign: "center"}}
          subheader={
            pastery.allergens.length > 0 &&
            helper.convertAllergensOfPasteryToStringOfAbbrevations(
              pastery.allergens
            )
          }
          sx={{ whiteSpace: "normal", p: 0, m: "auto", fontWeight:"bold", fontSize:14  }}
          disableTypography
        />
        <CardContent
          sx={{margin:"auto", padding:"auto"}}
        >
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize:"12px", textWrap: "wrap", margin:"auto", textAlign:"left"}}>
          {pastery.description}
        </Typography>
        </CardContent>
        <CardActionArea sx={{ width: "95%", display: "flex", margin:"auto", marginBottom:"1%" }}>
        <SizeSelector
            prices={pastery.price_set}
            setSelectedPrice={setSelectedPrice}
            style={{ width: "50%" }}
          />
          <Typography sx={{ margin: "auto" }} variant="h6">
            {selectedPrice && Number(selectedPrice.price)}€
          </Typography>
          <IconButton
            variant="contained"
            color="primary"
            sx={{backgroundColor: "#FFEEC3"}}
            onClick={() => {
              pastery.price = selectedPrice;
              addToCart.mutate(pastery);
            }}
          >
            <AddShoppingCartIcon />
          </IconButton>
        </CardActionArea>
      </Box>
    </Card>
  );
}


